import { CommentObj } from 'src/app/shared/interfaces/comment-obj';
import { Cruise } from '../models/cruise';
import { Itineraries } from '../models/itineraries';

export class CruiseWrapper {
  private cruise: Cruise;
  public constructor(cruise: Cruise) {
    this.cruise = cruise;
  }

  public getCruise(): Cruise {
    return this.cruise;
  }

  public getBeam(): string {
    return this.cruise.beam;
  }

  public getCategory(): number {
    return this.cruise.category;
  }

  public getCategoryII(): string {
    return this.cruise.categoryII;
  }

  public getCode(): number {
    return this.cruise.code;
  }

  public getDescription(): string {
    return this.cruise.description;
  }

  public getDraft(): string {
    return this.cruise.draft;
  }

  public getImage(): string {
    return this.cruise.image;
  }

  public getImages(): [] {
    return this.cruise.images;
  }

  public getItineraries(): Itineraries | undefined {
    return this.cruise.itineraries;
  }

  public getItineraryTypes(): [] {
    return this.cruise.itineraryTypes;
  }

  public getKeyFeatures(): string[] {
    return this.cruise.keyFeatures;
  }

  public getLenght(): string {
    return this.cruise.lenght;
  }

  public getMaximumAgeChild(): number {
    return this.cruise.maximumAgeChild;
  }

  public getMinimumAgeChild(): number {
    return this.cruise.minimumAgeChild;
  }

  public getMostAffordableDeparture(): number {
    return this.cruise.mostAffordableDeparture;
  }

  public getName(): string {
    return this.cruise.name;
  }

  public getPassengers(): number {
    return this.cruise.passengers;
  }
  public getTipoPaqueteEcommerce(): number | null {
    try {
      const currentItinerary: any = this.getCurrentItinerary();
      if (
        !this.isNullOrUndefined(currentItinerary) &&
        !this.isNullOrUndefined(currentItinerary.packageCode)
      ) {
        return currentItinerary.packageCode;
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  }
  public getSpeed(): string {
    return this.cruise.speed;
  }

  public getType(): string {
    return this.cruise.type;
  }

  public getYear(): number {
    return this.cruise.year;
  }

  public getIterIndex(): number | undefined {
    return this.cruise.iterIndex;
  }

  public getLongName(): string {
    return this.cruise.name + ' ' + this.cruise.type;
  }

  public getStartAndEndDataSummary(): string | undefined {
    return this.cruise.iterIndex
      ? this.cruise.availability[this.cruise.iterIndex].dateLong
      : undefined;
  }

  public getCruiseItineraryDuration(): string {
    if(this.cruise.itineraries){

      return this.cruise.iterIndex
        ? this.cruise.itineraries[this.cruise.iterIndex].length + '-Day'
        : '';
    }else{
      return '';
    }
  }

  public getCurrentItineraryIndex(): any {
    try {
      return this.getCruise().iterIndex;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  public getCurrentItinerary(): any {
    try {
      const i: number = this.getCurrentItineraryIndex()
        ? this.getCurrentItineraryIndex()
        : 0;
      return this.getCruise().availability[i];
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public getCurrentItinerarynew(): any {
    try {
      const i = this.getCurrentItineraryIndex()
        ? this.getCurrentItineraryIndex()
        : 0;
      return this.getCruise().availability[i];
    } catch (error) {
      console.log('CruiseWrapper.getCurrentItinerarynew()');
      console.error(error);
      return null;
    }
  }

  public getItineraryName(): string {
    let i: number = 0;
    i = this.cruise.iterIndex ? this.cruise.iterIndex : 0;
    return this.cruise.availability[i].name;
  }

  public getTipoPaqueteEcommerceinNewFormat(): any {
    try {
      const currentItinerary: any = this.getCurrentItinerarynew();
      if (
        !this.isNullOrUndefined(currentItinerary) &&
        !this.isNullOrUndefined(currentItinerary.packageCode)
      ) {
        return currentItinerary.packageCode;
      }
    } catch (error) {
      console.log('CruiseWrapper.getTipoPaqueteEcommerce()');
      console.error(error);
    }
    return null;
  }

  public getEdadMinima(): number {
    try {
      return this.getCruise().minimumAgeChild;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }

  public getEdadNino(): number {
    try {
      return this.getCruise().maximumAgeChild;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }

  public getMinBirthDateForChild(): Date {
    try {
      const today = new Date();
      const minAge = this.getEdadMinima();
      return new Date(
        today.getFullYear() - minAge,
        today.getMonth(),
        today.getDate()
      );
    } catch (error) {
      console.error(error);
      return new Date();
    }
  }

  public getMaxBirthDateForChild(): Date {
    try {
      const today = new Date();
      const childrenMaxAge = this.getEdadNino();
      if (childrenMaxAge === 0) {
        return new Date();
      }
      const minBirthDateForAdult = new Date(
        today.getFullYear() - childrenMaxAge,
        today.getMonth(),
        today.getDate()
      );
      return minBirthDateForAdult;
    } catch (error) {
      console.error(error);
      return new Date();
    }
  }

  public getItineraryDepartureTime(): Date {
    try {
      const valueItineraries: any = this.getCruise()?.itineraries;
      return new Date(
        valueItineraries
          ? valueItineraries[this.getCurrentItineraryIndex()].fechaSalida
          : new Date()
      );
    } catch (error) {
      console.error(error);
      return new Date();
    }
  }

  public getOverAllRating(isCruiselayout?: boolean): string {
    try {
      let promedio = 0;

      const valueitinerary = isCruiselayout
        ? this.getGenericItineraryRating()
        : this.getItineraryRating();

      let acommodation: any = 0;
      acommodation = this.getCruise().accommodationRating
        ? this.getCruise().accommodationRating
        : 0;

      promedio =
        (acommodation + this.getCruise().serviceRating + valueitinerary) / 3;
      return promedio.toFixed(1);
    } catch (error) {
      // console.error(error);
      return '0';
    }
  }

  public getGenericItineraryRating(): number {
    try {
      let response = 0;
      const itineraries: any = this.getCruise().itineraries;
      let allItinerariesRaiting = 0;
      itineraries.forEach((itemItinerary: any) => {
        let promedio = 0;

        promedio =
          (itemItinerary.floraFaunaRating +
            itemItinerary.landscapesRating +
            itemItinerary.activitiesRating) /
          3;
        allItinerariesRaiting = allItinerariesRaiting + promedio;
      });
      response = allItinerariesRaiting / itineraries.length;
      return Number(response.toFixed(1));
    } catch (error) {
      // console.error(error);
      return 0;
    }
  }

  public getItineraryRating(): number {
    try {
      let availabilities = [];
      let response = 0;
      availabilities = this.getCruise().availability;
      availabilities.forEach((avail) => {
        const itineraries: any = this.getCruise().itineraries;
        const itinerary = itineraries.find(
          (item: any) => item.code === avail.itinerary
        );
        let promedio = 0;
        promedio =
          (itinerary.floraFaunaRating +
            itinerary.landscapesRating +
            itinerary.activitiesRating) /
          3;
        if (response < promedio) {
          response = promedio;
        }
      });

      return Math.round(response);
    } catch (error) {
      // console.error(error);
      return 0;
    }
  }

  public getCurrentItineraryForLogs(): any {
    try {
      const i: number = this.getCurrentItineraryIndex()
        ? this.getCurrentItineraryIndex()
        : 0;
      const itinerary = this.getCruise().availability[i];
      const itineraryForLogs = {
        name : itinerary.name,
        startDate : new Date(itinerary.startDate).toISOString(),
        endDate : new Date(itinerary.endDate).toISOString(),
        dateLong : new Date().toISOString(),
        length : itinerary.length,
        rackPrice  : itinerary.rackPrice,
        promotionType : itinerary.promotionType,
        charterOnly : itinerary.charterOnly,
        groupsOnly : itinerary.groupsOnly,
      }
      return itineraryForLogs ;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

public getMainComent(): number {
  try {
    return this.getCruise().mainComment ?? 0;
  } catch (error) {
    console.error(error);
    return 0;
  }
}

  public getCommentsOrderedByDate(): CommentObj[] {
    let auxComments: CommentObj[] = [];
    if (this.getComments()) {
      auxComments = this.getComments().sort((t1, t2) => {
        const name1: Date = new Date(t1.date);
        const name2: Date = new Date(t2.date);

        if (name1 < name2) {
          return 1;
        }
        if (name1 > name2) {
          return -1;
        }
        return 0;
      });
    }
    return auxComments;
  }

public getComments(): CommentObj[] {
  try {
    return this.getCruise().comments ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
}


}
